// No need for a default export >> need to look at changing this rule
// eslint-disable-next-line import/prefer-default-export
import { DateTime } from 'luxon';

export const selectCurrentMember = (state) =>
  state.backendService.currentMember;

export const selectCurrentMemberSubscriptionExpiryDate = (state) =>
  state.backendService?.currentMember?.subscriptionExpiryDate
    ? `${state.backendService.currentMember.subscriptionExpiryDate}`
    : undefined;

export const selectHasCurrentMemberActiveSubscription = (state) => {
  const subscriptionExpiryDateValue = DateTime.fromISO(
    state.backendService?.currentMember?.subscriptionExpiryDate,
  );
  return (
    subscriptionExpiryDateValue && subscriptionExpiryDateValue > DateTime.now()
  );
};

export const selectCurrentMemberId = (state) =>
  state.backendService?.currentMember?.id
    ? `${state.backendService.currentMember.id}`
    : undefined;
